import { object } from 'yup'
import { MultiStepSchema } from 'components/Wizards/schemas/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { filename } from 'components/Wizards/schemas/shared/filename'
import { designProject } from 'components/Wizards/schemas/shared/designProject'
import { tone } from 'components/Wizards/schemas/shared/voiceTones'
import { language } from 'components/Wizards/schemas/shared/language'
import { brandKitId } from 'components/Wizards/schemas/shared/brandKitId'
import { meta } from '../schemaCommon'

export const FlowH1Schema = ({ generationType }: { generationType: string }) => {
  const SourceSelection = object({
    source_type: object().optional(),
    source_content: object().optional(),
    brand_kit_id: brandKitId.optional(),
    tone: tone.optional().meta({ generationType }),
    language: language,
    filename: filename.optional(),
    project: designProject.optional(),
  }).meta({
    title: 'Pick a source',
    type: generationType,
  })

  return {
    meta,
    steps: [SourceSelection],
  } as MultiStepSchema<GenerationType>
}
